import React, { useState, useEffect } from 'react';
import { entregaComputadorService } from '../services/api';
import { jsPDF } from 'jspdf';

function EntregaComputadorLista({ onEditar, tipo }) {
    const [entregas, setEntregas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        carregarEntregas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const carregarEntregas = async () => {
        try {
            setLoading(true);
            const response = await entregaComputadorService.listarTodas();
            setEntregas(response.data);
            setErro(null);
        } catch (error) {
            setErro('Erro ao carregar entregas');
        } finally {
            setLoading(false);
        }
    };

    const handleMudarStatus = async (entrega, novoStatus) => {
        if (window.confirm(`Alterar status para "${novoStatus}"?`)) {
            try {
                await entregaComputadorService.atualizar(entrega.id, {
                    ...entrega,
                    status: novoStatus
                });
                carregarEntregas();
            } catch (error) {
                alert('Erro ao atualizar status');
            }
        }
    };

    const gerarTermoPDF = (entrega) => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 20;
        const contentWidth = pageWidth - margin * 2;
        let y = 20;

        const colaborador = entrega.colaborador || {};
        const computador = entrega.computador || {};
        const acessorios = entrega.acessorios || '';

        const bold = () => doc.setFont('helvetica', 'bold');
        const normal = () => doc.setFont('helvetica', 'normal');
        const size = (s) => doc.setFontSize(s);

        // ===== CABEÇALHO =====
        bold(); size(12);
        doc.text('TRANSPIRATININGA LOGÍSTICA E LOCAÇÃO DE VEÍCULOS LTDA.', pageWidth / 2, y, { align: 'center' });
        y += 7;

        normal(); size(10);
        doc.text('CNPJ: 59.275.594/0001-96', pageWidth / 2, y, { align: 'center' });
        y += 10;

        bold(); size(11);
        doc.text('TERMO DE USO – REGRAS E PROCEDIMENTOS PARA UTILIZAÇÃO', pageWidth / 2, y, { align: 'center' });
        y += 6;
        doc.text('DE COMPUTADOR', pageWidth / 2, y, { align: 'center' });
        y += 12;

        // ===== TABELA COLABORADOR =====
        doc.rect(margin, y, contentWidth, 9);
        bold(); size(10);
        doc.text(`USUÁRIO: ${(colaborador.nome || '').toUpperCase()}`, margin + 3, y + 6);
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`MATRÍCULA: ${colaborador.registro || ''}`, margin + 3, y + 6);
        const dataAdmissao = colaborador.dataAdmissao
            ? new Date(colaborador.dataAdmissao + 'T00:00:00').toLocaleDateString('pt-BR')
            : '';
        doc.text(`DATA DE ADMISSÃO: ${dataAdmissao}`, margin + contentWidth / 2 + 3, y + 6);
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`CARGO: ${(colaborador.cargo || '').toUpperCase()}`, margin + 3, y + 6);
        doc.text(`DEPARTAMENTO: ${(entrega.departamento || colaborador.departamento || '').toUpperCase()}`, margin + contentWidth / 2 + 3, y + 6);
        y += 14;

        // ===== TABELA COMPUTADOR =====
        doc.rect(margin, y, contentWidth, 9);
        bold(); size(10);
        doc.text('COMPUTADOR', pageWidth / 2, y + 6, { align: 'center' });
        y += 9;

        doc.rect(margin, y, contentWidth / 2, 9);
        doc.rect(margin + contentWidth / 2, y, contentWidth / 2, 9);
        bold(); size(10);
        doc.text(`Nº PATRIMÔNIO: ${computador.numeroPatrimonio || ''}`, margin + 3, y + 6);
        doc.text(`Nº SÉRIE: ${computador.numeroSerie || ''}`, margin + contentWidth / 2 + 3, y + 6);
        y += 9;

        // acessórios
        const temCarregador = acessorios.toLowerCase().includes('carregador') ? 'SIM' : 'NÃO';
        const temMouse = acessorios.toLowerCase().includes('mouse') ? 'SIM' : 'NÃO';
        const temTeclado = acessorios.toLowerCase().includes('teclado') ? 'SIM' : 'NÃO';
        const temMonitor = acessorios.toLowerCase().includes('monitor') ? 'SIM' : 'NÃO';
        const temMochila = acessorios.toLowerCase().includes('mochila') || acessorios.toLowerCase().includes('case') ? 'SIM' : 'NÃO';

        const linhasDetalhes = [
            `Marca: ${computador.marca || ''}`,
            `Modelo: ${computador.modelo || ''}`,
            `Nº Série: ${computador.numeroSerie || ''}`,
            `MAC Address: ${computador.macAddress || ''}`,
            `CARREGADOR: ${temCarregador}`,
            `MOUSE: ${temMouse}`,
            `TECLADO: ${temTeclado}`,
            `MONITOR: ${temMonitor}`,
            `MOCHILA/CASE: ${temMochila}`,
            `ACESSÓRIOS ADICIONAIS: ${acessorios || 'N/A'}`,
        ];

        const alturaDetalhes = linhasDetalhes.length * 5 + 4;
        doc.rect(margin, y, contentWidth, alturaDetalhes);
        normal(); size(9);
        linhasDetalhes.forEach((linha, i) => {
            doc.text(linha, margin + 3, y + 5 + i * 5);
        });
        y += alturaDetalhes + 8;

        // ===== CLÁUSULAS =====
        normal(); size(9);

        const clausulas = [
            '1- O fornecimento do equipamento acima descrito tem por finalidade facilitar e permitir a execução das atividades profissionais do USUÁRIO-COLABORADOR. O equipamento é de propriedade da EMPRESA, sendo terminantemente proibido o empréstimo, aluguel ou cessão a terceiros.',
            '2- O equipamento somente poderá ser utilizado para fins profissionais relacionados às atividades da empresa, sendo expressamente vedado o uso para fins pessoais.',
            '3- É de responsabilidade do USUÁRIO-COLABORADOR cuidar, zelar e manter pela conservação do equipamento, utilizando-o dentro das regras básicas recomendadas pelo fabricante, sob pena de arcar com as despesas de reposição ou conserto em função de desleixo, falta de cuidado e descaso.',
            '4- Em caso de perda, extravio, furto ou roubo do equipamento, o USUÁRIO-COLABORADOR deverá, de imediato, avisar a área da controladoria da empresa.',
            '5- A EMPRESA poderá, a qualquer tempo, independentemente de comunicado prévio ou anuência do USUÁRIO-COLABORADOR, requisitar de imediato o equipamento para inspeção, vistoria ou atualização de softwares.',
            '6- O USUÁRIO-COLABORADOR não deverá instalar programas, aplicativos ou softwares não autorizados pela empresa.',
            '7- É expressamente proibida a navegação em sites de conteúdo pornográfico, de compartilhamento ilegal de arquivos, de relacionamento pessoal, violência, pirataria e similares.',
            '8- O USUÁRIO-COLABORADOR não deverá armazenar arquivos pessoais (músicas, vídeos, fotos) no equipamento da empresa.',
            '9- Estas regras e procedimentos integram o contrato de trabalho do USUÁRIO-COLABORADOR.',
            '10- O USUÁRIO-COLABORADOR declara neste ato que: a) Recebeu o equipamento com todos os itens originais que o compõem. b) Está ciente de que não deve instalar qualquer senha que inviabilize o uso posterior por pessoa diversa. c) Deve respeitar as normas de segurança e restrições impostas pela empresa. d) Utilizará o e-mail corporativo somente para fins profissionais.',
            '11- O USUÁRIO-COLABORADOR deverá ressarcir inteiramente os danos causados. Se o dano inviabilizar por completo o uso do equipamento, deverá arcar com os custos integrais de um equipamento novo, de modelo igual ou similar.',
            '12- Qualquer problema referente ao uso do equipamento da empresa deverá, imediatamente, ser relatado à mesma.',
            '13- O USUÁRIO-COLABORADOR assumirá a responsabilidade pelo dano que possa causar caso não venha a cumprir o disposto neste termo. Declarando, nesta data, ter ciência e estar de acordo com os procedimentos acima descritos, comprometendo-se a respeitá-los e cumpri-los plena e integralmente.',
        ];

        clausulas.forEach((clausula) => {
            normal(); size(9);
            const linhas = doc.splitTextToSize(clausula, contentWidth);
            if (y + linhas.length * 4.5 + 5 > 275) {
                doc.addPage();
                y = 20;
            }
            doc.text(linhas, margin, y);
            y += linhas.length * 4.5 + 4;
        });

        // ===== DATA E ASSINATURA =====
        if (y + 35 > 275) {
            doc.addPage();
            y = 20;
        }

        y += 8;
        const dataEntrega = entrega.dataEntrega
            ? new Date(entrega.dataEntrega + 'T00:00:00').toLocaleDateString('pt-BR', {
                day: '2-digit', month: 'long', year: 'numeric'
              })
            : '_____ de _____________ de _____';

        normal(); size(10);
        doc.text(`São Caetano do Sul, ${dataEntrega}`, margin, y);
        y += 18;

        doc.line(margin, y, margin + 90, y);
        y += 5;
        bold(); size(10);
        doc.text((colaborador.nome || '').toUpperCase(), margin, y);

        const nomeArquivo = `termo-computador-${(colaborador.nome || 'colaborador').replace(/\s+/g, '-').toLowerCase()}-${computador.numeroPatrimonio || ''}.pdf`;
        doc.save(nomeArquivo);
    };

    if (loading) return <div className="text-center">Carregando...</div>;
    if (erro) return <div className="alert alert-danger">{erro}</div>;

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">📦 Lista de Entregas</h5>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>Patrimônio</th>
                                <th>Modelo</th>
                                <th>Colaborador</th>
                                <th>Departamento</th>
                                <th>Data Entrega</th>
                                <th>Status</th>
                                {tipo === 'ADMIN' && <th className="text-center">Ações</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {entregas.length === 0 ? (
                                <tr>
                                    <td colSpan={tipo === 'ADMIN' ? 7 : 6} className="text-center text-muted">
                                        Nenhuma entrega cadastrada
                                    </td>
                                </tr>
                            ) : (
                                entregas.map((entrega) => (
                                    <tr key={entrega.id}>
                                        <td>{entrega.computador?.numeroPatrimonio || '-'}</td>
                                        <td>{entrega.computador?.modelo || '-'}</td>
                                        <td>{entrega.colaborador?.nome || '-'}</td>
                                        <td>{entrega.departamento || '-'}</td>
                                        <td>{new Date(entrega.dataEntrega).toLocaleDateString('pt-BR')}</td>
                                        <td>
                                            <span className={`badge ${
                                                entrega.status === 'ativo' ? 'bg-success' :
                                                entrega.status === 'devolvido' ? 'bg-secondary' :
                                                'bg-danger'
                                            }`}>
                                                {entrega.status}
                                            </span>
                                        </td>
                                        {tipo === 'ADMIN' && (
                                            <td className="text-center text-nowrap">
                                                <button onClick={() => onEditar(entrega)} className="btn btn-sm btn-warning me-1">✏️ Editar</button>
                                                <button onClick={() => gerarTermoPDF(entrega)} className="btn btn-sm btn-primary me-1">📄 Termo</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'ativo')} className="btn btn-sm btn-success me-1" disabled={entrega.status === 'ativo'}>✅ Ativo</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'devolvido')} className="btn btn-sm btn-secondary me-1" disabled={entrega.status === 'devolvido'}>↩️ Devolvido</button>
                                                <button onClick={() => handleMudarStatus(entrega, 'atrasado')} className="btn btn-sm btn-danger" disabled={entrega.status === 'atrasado'}>⚠️ Atrasado</button>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default EntregaComputadorLista;